/* hs-eslint ignored failing-rules */

import Log from 'forms-utils-lib/logger/Logger';
import getLegalConsentCopy from 'forms-utils-lib/api/legalConsent/getLegalConsentCopy';
import getUpdatedLegalConsentCheckbox from 'forms-utils-lib/legalConsent/getUpdatedLegalConsentCheckbox';
import addOrUpdateCommunicationCheckbox from 'forms-utils-lib/legalConsent/addOrUpdateCommunicationCheckbox';

// @ts-expect-error missing types
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { getFormsLangToLegalConsentLang } from 'FormsUI/utils/Lang';
// @ts-expect-error missing types
import { getLegalConsentOptions } from 'FormsUI/selectors/LegalConsent';
// @ts-expect-error missing types
import { updateLegalConsent } from 'FormsUI/actions/LegalConsent';
// @ts-expect-error missing types
import { getFormLanguage } from 'FormsUI/selectors/FormDefinition';
import getUnselectedSubscriptionsForLegalConsent from 'FormsUI/selectors/legalConsent/getUnselectedSubscriptionsForLegalConsent';
import getBusinessUnitIdForLegalConsentCheckbox from 'FormsUI/selectors/legalConsent/getBusinessUnitIdForLegalConsentCheckbox';
import { trackUpdateGdprCheckbox } from 'FormsUI/tracking/legalConsentTracking';
const updateLegalConsentCheckbox = (checkbox, oldCheckbox) => (dispatch, getState) => {
  const state = getState();
  const legalConsent = getLegalConsentOptions(state);
  const language = getFormLanguage(state);
  const subscriptions = getUnselectedSubscriptionsForLegalConsent(state);
  const businessUnitId = getBusinessUnitIdForLegalConsentCheckbox(state, checkbox);
  return getLegalConsentCopy({
    language: getFormsLangToLegalConsentLang(language),
    businessUnitId
  }).then(({
    consentCheckboxes
  }) => {
    const updatedCheckbox = getUpdatedLegalConsentCheckbox({
      subscriptions,
      consentCheckboxes,
      checkbox,
      oldCheckbox
    });
    const updatedLegalConsentOptions = addOrUpdateCommunicationCheckbox({
      legalConsent: legalConsent.toJS(),
      checkbox: updatedCheckbox,
      oldCheckbox
    });
    trackUpdateGdprCheckbox();
    dispatch(updateLegalConsent(new LegalConsent(updatedLegalConsentOptions)));
  }).catch(e => {
    Log.logServiceError('Fail to update legal consent checkbox', e);
  });
};
export default updateLegalConsentCheckbox;